import { getCtoLabel, getCtoGroupKey } from './networkMonitoring';

export const MONITORING_SIGNAL_LEVELS = [
    { label: 'Crítico', color: '#dc2626' },
    { label: 'Ruim', color: '#f97316' },
    { label: 'Bom', color: '#86efac' },
    { label: 'Ótimo', color: '#16a34a' },
    { label: 'Excelente', color: '#166534' },
    { label: 'Sem leitura', color: '#94a3b8' },
];

export function getMonitoringSignalLevel(signal, threshold = -27) {
    const rx = Number(signal);
    const limit = Number(threshold);
    if (signal == null || String(signal).trim() === '' || !Number.isFinite(rx) || rx >= 0) return MONITORING_SIGNAL_LEVELS[5];
    if (rx <= -30) return MONITORING_SIGNAL_LEVELS[0];
    if (rx < (Number.isFinite(limit) ? limit : -27)) return MONITORING_SIGNAL_LEVELS[1];
    if (rx < -24) return MONITORING_SIGNAL_LEVELS[2];
    if (rx < -20) return MONITORING_SIGNAL_LEVELS[3];
    return MONITORING_SIGNAL_LEVELS[4];
}

export function validMapCoordinates(coords) {
    const parse = value => value == null || String(value).trim() === '' ? NaN : Number(String(value).trim().replace(',', '.'));
    const lat = parse(coords?.lat);
    const lng = parse(coords?.lng);
    return Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180 && (lat !== 0 || lng !== 0)
        ? { lat, lng } : null;
}

// Every client contributes to density; worse Rx adds more weight to the heatmap.
export function getSignalHeatWeight(signal, threshold = -27) {
    const rx = Number(signal);
    const limit = Number(threshold);
    return Number.isFinite(rx) && signal != null
        ? Math.min(1, 0.25 + Math.max(0, (Number.isFinite(limit) ? limit : -27) - rx) / 10) : 0.25;
}

export function getMonitoringCtoTooltip(cto) {
    const number = String(cto.name || '').match(/\bCTO\s*[-:]?\s*(\d+(?:[.,/-]\d+)*)/i)?.[1];
    const label = number ? `CTO ${number}` : (cto.id ? `CTO ${cto.id}` : 'CTO');
    return `${label} ${Number.isFinite(cto.averageSignal) ? `${cto.averageSignal.toFixed(2)} dBm` : 'sem leitura'}`;
}

export function buildMonitoringMapData(clients, boxes = []) {
    const activeClients = clients.filter(client => client.loginActive === true);
    const locatedClients = [];
    const ctos = new Map();
    const signals = new Map();
    boxes.forEach(box => {
        if (box.id == null || String(box.id) === '0') return;
        const id = String(box.id);
        ctos.set(`id:${id}`, { key: `id:${id}`, id, name: box.name || `CTO ${id}`, coordinates: validMapCoordinates(box.coordinates), oltId: box.oltId, count: 0, clients: [] });
    });
    activeClients.forEach(client => {
        const coordinates = validMapCoordinates(client.coordinates);
        const locatedClient = coordinates ? { ...client, coordinates } : null;
        if (locatedClient) locatedClients.push(locatedClient);
        const key = client.ctoId ? `id:${client.ctoId}` : getCtoGroupKey(client);
        const ctoCoordinates = validMapCoordinates(client.ctoCoordinates);
        const cto = ctos.get(key) || { key, id: client.ctoId || null, name: getCtoLabel(client), coordinates: null, count: 0, clients: [] };
        cto.coordinates = cto.coordinates || ctoCoordinates;
        cto.count++;
        const signal = Number(client.signal);
        if (client.signal != null && String(client.signal).trim() !== '' && Number.isFinite(signal) && signal < 0) {
            const readings = signals.get(key) || { sum: 0, count: 0 };
            readings.sum += signal;
            readings.count++;
            signals.set(key, readings);
        }
        if (locatedClient) cto.clients.push(locatedClient);
        ctos.set(key, cto);
    });
    return {
        clients: locatedClients,
        ctos: [...ctos.values()].filter(cto => cto.coordinates).map(cto => {
            const readings = signals.get(cto.key);
            return { ...cto, averageSignal: readings ? readings.sum / readings.count : null };
        }),
        missingClients: activeClients.length - locatedClients.length,
        missingCtos: [...ctos.values()].filter(cto => !cto.coordinates).length,
    };
}
